import {defineField} from 'sanity'

export default defineField({
  name: 'modules',
  type: 'array',
  of: [
    {type: 'page.title'},
    {type: 'featured-posts'},
    {type: 'inline-search-section'},
    {type: 'posts-by-tag'},
    {type: 'posts-by-category'},
    {type: 'posts-slider'},
    {type: 'videos-slider'},
    {type: 'content-section'},
    {type: 'featured-cruises-section'},
  ],
})
